/**
 * Created by tanjj4 on 2018-2-8.
 */

const testServer = 'https://mcsp-api-sit.midea.com/api/mcsp_api/cbc-api-service/ic/mcsp/item/outer/ms/product/';

const prdServer = process.env.BASE_API || 'https://mcsp.midea.com/api/mcsp_ic/item-application-service/mcsp/item/outer/ms/product/'; //迁移后为dcp
const rdmCustomerType = 'wechat/model-rdm';
const normalCustomerType = 'wechat/model.do?apikey=' + process.env.apikey;

const searchProduct = 'wechat/searchProduct.do?apikey=' + process.env.apikey;
const myBrowsingHistory = 'wechat/myBrowsingHistory.do?apikey=' + process.env.apikey;
const myCollections = 'wechat/myCollections.do?apikey=' + process.env.apikey;
const products = 'wechat/products.do?apikey=' + process.env.apikey; // 根据品类查询商品
const product = 'wechat/product.do?apikey=' + process.env.apikey; // 根据品类查询商品
const mainCategories = 'wechat/mainCategories.do?apikey=' + process.env.apikey;
const childrenCategories = 'wechat/childrenCategories.do?apikey=' + process.env.apikey;
const scan = 'wechat/scan.do?apikey=' + process.env.apikey;
const cancelCollection = 'wechat/cancelCollection.do?apikey=' + process.env.apikey;
const collection = 'wechat/collection.do?apikey=' + process.env.apikey;


let server = testServer;
let customerType = normalCustomerType;
const ENV = {};
if (Object.keys(ENV).length === 0) {
    ENV.TEST_AND_NORMAL = 0;
    ENV.TEST_AND_RDM = 1;
    ENV.PROD_AND_NORMAL = 2;
    ENV.PROD_AND_RDM = 3;
    // ENV.PROD_AND_NORMAL = 2;  // 生产环境普通版本
    // ENV.PROD_AND_RDM = 3; // 生产环境RDM版本
}
//注意：修改环境配置的在这里 //todo
const setEnv = ENV.PROD_AND_NORMAL;
switch (setEnv) {
    case ENV.TEST_AND_NORMAL:
        server = testServer;
        customerType = normalCustomerType;
        break;
    case ENV.TEST_AND_RDM:
        server = testServer;
        customerType = rdmCustomerType;
        break;
    case ENV.PROD_AND_NORMAL:
        server = prdServer;
        customerType = normalCustomerType;
        break;
    case ENV.PROD_AND_RDM:
        server = prdServer;
        customerType = rdmCustomerType;
        break;
    default:
        break;
}

const apiConfig = {
    serverAddress: server,
    customerType: customerType,
    searchProduct: searchProduct,
    myBrowsingHistory: myBrowsingHistory,
    myCollections: myCollections,
    products: products,
    mainCategories: mainCategories,
    childrenCategories: childrenCategories,
    product: product,
    scan: scan,
    cancelCollection: cancelCollection,
    collection: collection,
    
};

export default apiConfig




// WEBPACK FOOTER //
// ./src/api.js